import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { deleteMenu, getAllMenu } from "../../redux/chefSlice";
import {
  displayError,
  displaySuccess,
  formatDateToDateString,
  sortByMenuDate,
} from "../../utils/util-functions";

const ViewMenusCard = (props) => {
  const dispatch = useDispatch();
  const canEdit = (date) => {
    const menuDate = new Date(date);
    const today = new Date();
    if (today < menuDate) {
      return true;
    } else {
      return false;
    }
  };

  const deleteMenuItem = async (id) => {
    console.log(id);
    const response = await dispatch(deleteMenu(id)).unwrap();
    console.log(response);
    if (response.status === 200) {
      displaySuccess("Menu deleted successfully");
    } else {
      displayError("Unable to delete menu, please try again");
    }
  };

  // console.log( menus)

  const editMenuItem = (menu) => {
    // open the 3rd tab, ie edit menu
    // send editable data to current tab
    props.setCurrentTab(3);
    props.currentEditableMenuRef.current = menu;
  };
  return (
    <div className="sm:hidden w-full  box-outer-shadow rounded-3xl px-6 flex-col pt-6 text-primary mb-4 pb-4 ">
      <h1 className="mb-2 font-medium text-base text-primary break-words text-center">
        {props.date}
      </h1>
      <div className="grid grid-cols-2 gap-1">
        <div className="flex flex-col space-y-2">
          <h1 className="  text-sm font-normal text-primary/30 pb-2">Foods</h1>
          {props.foods.map((food) => (
            <span
              className="font-medium text-sm text-primary break-words flex  items-center   "
              key={food.food_id}
            >
              <span className="text-bluebullet">*</span>
              <span className="ml-[3px]">{food.food_name}</span>
            </span>
          ))}
        </div>
        <div className="flex flex-col space-y-2">
          <h1 className="  text-sm font-normal text-primary/30 pb-2">Drinks</h1>
          {props.drinks.map((drink) => (
            <span
              className="font-medium text-sm text-primary break-words  "
              key={drink.drink_id}
            >
              <span className="text-orangebullet ">*</span>
              <span className="ml-[3px]">{drink.drink_name}</span>
            </span>
          ))}
        </div>
      </div>
      {/* 
      <div className="mt-6 flex justify-evenly pb-4"> */}
      {canEdit(props.date) && (
        <div className="mt-6 flex justify-evenly ">
          <button className="" onClick={() => editMenuItem(props.menu)}>
            <svg
              className="fill-checkbox mx-auto"
              width="36"
              height="36"
              viewBox="0 0 36 36"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M28 30H6V8H19.22L21.22 6H6C5.46957 6 4.96086 6.21071 4.58579 6.58579C4.21071 6.96086 4 7.46957 4 8V30C4 30.5304 4.21071 31.0391 4.58579 31.4142C4.96086 31.7893 5.46957 32 6 32H28C28.5304 32 29.0391 31.7893 29.4142 31.4142C29.7893 31.0391 30 30.5304 30 30V15L28 17V30Z" />
              <path d="M33.53 5.84019L30.16 2.47019C30.0104 2.32022 29.8327 2.20123 29.6371 2.12005C29.4415 2.03886 29.2318 1.99707 29.02 1.99707C28.8082 1.99707 28.5985 2.03886 28.4028 2.12005C28.2072 2.20123 28.0295 2.32022 27.88 2.47019L14.17 16.2602L13.06 21.0702C13.0127 21.3033 13.0177 21.5441 13.0745 21.7751C13.1314 22.0061 13.2388 22.2216 13.3889 22.4062C13.539 22.5907 13.7282 22.7397 13.9428 22.8424C14.1574 22.9452 14.3921 22.999 14.63 23.0002C14.7529 23.0137 14.877 23.0137 15 23.0002L19.85 21.9302L33.53 8.12019C33.68 7.97063 33.7989 7.79295 33.8801 7.59733C33.9613 7.40171 34.0031 7.19199 34.0031 6.98019C34.0031 6.76839 33.9613 6.55867 33.8801 6.36305C33.7989 6.16743 33.68 5.98975 33.53 5.84019V5.84019ZM18.81 20.0802L15.15 20.8902L16 17.2602L26.32 6.87019L29.14 9.69019L18.81 20.0802ZM30.27 8.56019L27.45 5.74019L29 4.16019L31.84 7.00019L30.27 8.56019Z" />
            </svg>
          </button>

          <button className="ml-12" onClick={() => deleteMenuItem(props.id)}>
            <svg
              className="fill-red-500"
              width="27"
              height="27"
              viewBox="0 0 15 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.00213 7.20795e-05C5.90293 -0.00133488 5.80444 0.0178683 5.7124 0.0565665C5.62035 0.0952648 5.53658 0.152687 5.46595 0.225498C5.39532 0.298309 5.33923 0.385058 5.30095 0.480708C5.26267 0.576357 5.24296 0.679001 5.24296 0.782678H0.7596C0.660358 0.781211 0.561826 0.80037 0.469731 0.839042C0.377636 0.877713 0.293814 0.935126 0.223138 1.00794C0.152461 1.08076 0.0963388 1.16753 0.0580326 1.26321C0.0197264 1.35889 0 1.46157 0 1.56528C0 1.669 0.0197264 1.77168 0.0580326 1.86736C0.0963388 1.96304 0.152461 2.04981 0.223138 2.12262C0.293814 2.19544 0.377636 2.25285 0.469731 2.29152C0.561826 2.3302 0.660358 2.34936 0.7596 2.34789H14.2404C14.3396 2.34936 14.4382 2.3302 14.5303 2.29152C14.6224 2.25285 14.7062 2.19544 14.7769 2.12262C14.8475 2.04981 14.9037 1.96304 14.942 1.86736C14.9803 1.77168 15 1.669 15 1.56528C15 1.46157 14.9803 1.35889 14.942 1.26321C14.9037 1.16753 14.8475 1.08076 14.7769 1.00794C14.7062 0.935126 14.6224 0.877713 14.5303 0.839042C14.4382 0.80037 14.3396 0.781211 14.2404 0.782678H9.75704C9.75704 0.679001 9.73733 0.576357 9.69905 0.480708C9.66077 0.385058 9.60468 0.298309 9.53405 0.225498C9.46342 0.152687 9.37965 0.0952648 9.2876 0.0565665C9.19556 0.0178683 9.09707 -0.00133488 8.99787 7.20795e-05H6.00213ZM0.7596 3.9131V16.4348C0.7596 17.2996 1.4299 18 2.25747 18H12.7425C13.5701 18 14.2404 17.2996 14.2404 16.4348V3.9131H0.7596Z"
                fill=""
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default ViewMenusCard;
